import { i18n } from "@lingui/core";
import dayjs from "dayjs";

import { dayjsLocales } from "./dayjs";
import { configureValidation } from "./validation";

export const defaultLocale = "fr-FR";

export async function dynamicActivate(locale: string) {
  try {
    const { messages } = await import(`../locales/${locale}/messages.po`);

    if (messages) {
      i18n.loadAndActivate({ locale, messages });
      configureValidation(locale);
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (dayjsLocales[locale]) {
      dayjs.locale(await dayjsLocales[locale]());
    }
  } catch {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    throw new Error(`Failed to load messages for locale: ${locale}`);
  }
}
